import { OktaAuth } from '@okta/okta-auth-js';
import { Tokens } from '@okta/okta-auth-js/lib/types';
import { PostLoginHandlers, IdpType } from './types';
import OktaUserInfo from './okta-user-info';

export const getOktaLoginType = (): IdpType => {
  const oktaType = localStorage.getItem('oktaTenant');
  return (oktaType || IdpType.OktaB2E) as IdpType;
};

export const setOktaLoginType = (oktaType: IdpType): void => {
  localStorage.setItem('oktaTenant', oktaType);
};

export const buildPostLoginHandlers = (oktaAuth: OktaAuth): PostLoginHandlers => {
  return {
    onSuccess: (tokens?: Tokens) => {
      if (tokens) {
        oktaAuth.tokenManager.setTokens(tokens);
        
        // Get and store user profile
        oktaAuth.getUser().then((user) => {
          if (user) {
            OktaUserInfo.setOktaUserInfo({
              email: user.email || '',
              firstName: user.given_name || '',
              lastName: user.family_name || '',
              sub: user.sub || '',
            });
          }
        }).catch((error) => {
          console.error('Error getting user profile:', error);
        });
      }
    },
    onError: (err: Error) => {
      console.error('Login error:', err);
    },
  };
};

export const getUserDisplayName = (): string => {
  const userInfo = OktaUserInfo.getOktaUserInfo();
  return `${userInfo.firstName || ''} ${userInfo.lastName || ''}`.trim() || 'User';
};

export const getUserEmail = (): string => {
  const userInfo = OktaUserInfo.getOktaUserInfo();
  return userInfo.email || '';
};